import request from "@/utils/request";

// 获取页面详情
export function getPageDetail(data) {
  return request({
    method: "post",
    path: "page/detail",
    data,
  });
}
